import { useMemo } from "react";
import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "./actions";

export const useNotifications = () => {

  const {
    initialize,
    notificationPage,
    refresh,
    loadMore,
    total,
    isRequesting,
    countUnread
  } = useSelector((state) => state.notifications)

  const notifications = useSelector((state) =>
    state.notifications.push.map((notif) => { return notif })
  );

  const hasUnreadNotification = useMemo(
    () => notifications.some((notif) => !notif.is_read),
    [notifications]
  );

  const banner = useSelector((state) => state.notifications.banner);
  const dispatch = useDispatch();

  const setNotifications = useCallback(
    (payload) => dispatch(actions.setNotifications(payload)),
    [dispatch]
  );

  const addNotification = useCallback(
    (payload) => dispatch(actions.addNotification(payload)),
    [dispatch]
  );

  const setNotificationBanner = useCallback(
    (payload) => dispatch(actions.setNotificationBanner(payload)),
    [dispatch]
  );

  const setNotificationUserReads = useCallback(
    (payload) => dispatch(actions.setNotificationUserReads(payload)),
    [dispatch]
  );

  const addNotificationUserRead = useCallback(
    (payload) => dispatch(actions.addNotificationUserRead(payload)),
    [dispatch]
  );

  const updateMarkReadPushNotifications = useCallback(
    (payload) => dispatch(actions.updateMarkReadPushNotifications(payload)),
    [dispatch]
  );

  const updatePushNotificationUserAccess = useCallback(
    (payload) => dispatch(actions.updatePushNotificationUserAccess(payload)),
    [dispatch]
  );

  const fetchNotification = useCallback(
    (payload) => dispatch(actions.fetchNotification(payload)),
    [dispatch]
  );
  
  const refreshNotification = useCallback(
    (payload) => dispatch(actions.refreshNotification(payload)),
    [dispatch]
  )

  const finishGetNotifications = useCallback(
    (payload) => dispatch(actions.finishGetNotifications(payload)),
    [dispatch]
  )

  const getNotifications = useCallback(
    (payload) => dispatch(actions.getNotifications(payload)),
    [dispatch]
  )

  const notification_page_read = useCallback(
    (payload) => dispatch(actions.notification_page_read(payload)),
    [dispatch]
  );

  return {
    notifications,
    hasUnreadNotification,
    banner,
    initialize,
    notificationPage,
    refresh,
    loadMore,
    total,
    isRequesting,
    countUnread,
    setNotifications,
    addNotification,
    setNotificationBanner,
    setNotificationUserReads,
    addNotificationUserRead,
    updateMarkReadPushNotifications,
    updatePushNotificationUserAccess,
    fetchNotification,
    refreshNotification,
    finishGetNotifications,
    getNotifications,
    notification_page_read
  };
};
